import React, { useState } from 'react';
import { ProductFilterButton } from './ProductFilterButton';
import { ProductTaxo } from '../ProductTaxo';
import Accordion from 'react-bootstrap/Accordion';
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";
import './ProductFilter.scss';
import { MdAddCircleOutline, MdRemoveCircleOutline} from 'react-icons/md';

export function ProductFilter() {
  const [isIconClass, setIsIconClass] = useState(true);
  // console.log("----> ProductFilter");
  
  const defaultCateg = [
    { id: "selection-50-fonds", name: "Sélection des 50 fonds", key: 'b4b_partner:1' },
    { id: "meilleurs-fonds-notes", name: "Meilleurs fonds notés<br/>5 étoiles sur Morning Star", key: 'rating:5' },
    { id: "meilleurs-perf-1an", name: "Meilleures performances<br/>sur 1 an", key: 'performance_end_of_month_1_year:1' },
    { id: "meilleurs-perf-3an", name: "Meilleures performances<br/>sur 3 ans", key: 'performance_end_of_month_3_years:1' },
    { id: "fonds-0pourc", name: "Sélection de fonds à droits préférentiels", key: 'b4b_negociated_fee:1' }
  ];

  function CustomToggle({ children, eventKey }: any) {
    const onClickCustomToggle = useAccordionToggle(eventKey, () => {

      if (isIconClass === true) {
        setIsIconClass(false);
      } else {
        setIsIconClass(true);
      }

    });

    return (
      <button
        type="button"
        className={`btn btn-title text-primary custom-button`}
        onClick={onClickCustomToggle}
      >
        {children}
        {
          isIconClass ? <MdRemoveCircleOutline size={24}></MdRemoveCircleOutline> : <MdAddCircleOutline size={24}></MdAddCircleOutline>
      }
      
      </button>
    );
  }

  return (
    <div className="filters">
      <div className="box flex-row">
        <div className="box flex-col">
          <Accordion defaultActiveKey="0">

            <div className="mb-3" style={{ borderBottom: "1px solid #2D878D"}}>
            <CustomToggle eventKey="0">
                <p className="h3" style={{ width: "85%"}}>Affinez votre recherche avec plus de critères</p>
            </CustomToggle>
          </div>
          <Accordion.Collapse eventKey="0" className="mb-3">
            <ul className="list-unstyled pl-0 w-100 container-category-list">
              {defaultCateg.map((category: any, index: number) => (
                <li className="category-list-item" key={index}>
                  <ProductFilterButton category={category} />
                </li>
              ))}
            </ul>
          </Accordion.Collapse>
          </Accordion>
        </div>
        <ProductTaxo />
      </div>
    </div>
  );
}
